import { IOnInit } from "angular";
import { ContractBulkUpdateResponse } from "../../../shared/models/contract";

export class ContractPatchBulkResultController implements IOnInit {
  static $inject = [];

  bulkUpdateResponse!: ContractBulkUpdateResponse;

  $onInit(): void {
    //console.log(this.bulkUpdateResponse);
  }
}
